import { formFieldKeys } from '@messenger/consts'
import { formatMiddleInitial } from '@/utils/tinyMCE/formatMiddleInitial'

type FormatCaseDetailValueProps = {
  value: string
  path: string
}

export const formatCaseDetailValue = ({
  value,
  path,
}: FormatCaseDetailValueProps) => {
  let formattedValue = value

  const isEmptyPlaceholder = value === '\u200A' || value === '\u00A0'

  const shouldFormatNickName =
    path === formFieldKeys.nickName && value && !isEmptyPlaceholder
  const shouldFormatMaidenName =
    path === formFieldKeys.maidenName && value && !isEmptyPlaceholder
  const shouldFormatMiddleName =
    path === formFieldKeys.middleName && value && !isEmptyPlaceholder

  if (shouldFormatNickName) {
    formattedValue = `"${value}"`
  } else if (shouldFormatMaidenName) {
    formattedValue = `(${value})`
  } else if (shouldFormatMiddleName) {
    formattedValue = formatMiddleInitial(value)
  }
  return formattedValue
}
